import React from 'react';
import { connect } from 'react-redux';
import WorkspaceCards from '@/workspaces/components/WorkspaceCards';
import WorkspaceHubsDropdown from '@/workspaces/components/WorkspaceHubsDropdown';
import FormValidationError from '@/components/errors/FormValidationError';
import RequestWorkspacesContainer, {
  mapStateToProps,
  mapDispatchToProps,
} from './RequestWorkspacesContainer';

const RequestWorkspaceList = ({
  category,
  code,
  fetchLocations,
  fetchWorkspaces,
  hasConditions,
  location,
  locations,
  locationsReadStatus,
  onCheckBoxClick,
  onClick,
  readErrors,
  readStatus,
  workspaces,
}) => (
  <RequestWorkspacesContainer
    category={category}
    code={code}
    fetchLocations={fetchLocations}
    readStatus={locationsReadStatus}
  >
    {locations.length > 1 && (
    <FormValidationError
      htmlFor="workspace_hubs_dropdown"
      labelId="access.destination.workspace.url"
    >
      <WorkspaceHubsDropdown
        className="aridhia-list-filter"
        locations={locations}
        readStatus={readStatus}
        location={location}
        onChange={(value) => fetchWorkspaces(category, code, value)}
        fluid
      />
    </FormValidationError>
    )}
    <WorkspaceCards
      category={category}
      hasConditions={hasConditions}
      items={workspaces}
      onCheckBoxClick={(value) => onCheckBoxClick(category, code, value)}
      onClick={onClick}
      readErrors={readErrors}
      readStatus={readStatus}
      itemsPerRow={1}
      single
    />
  </RequestWorkspacesContainer>
);

export default connect(mapStateToProps, mapDispatchToProps)(RequestWorkspaceList);
